export default __webpack_public_path__ + "static/media/Ma009-4.85573fe3.svg";